import React from 'react'


export default function Home() {
    return (
        <>
            <div className=" netflix my-0">
                <div id="carouselExampleCaptions" className="carousel slide my-0" data-bs-ride="carousel">

                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src='img/home1.jfif' className="d-block w-100" alt="..." />
                            <div className="carousel-caption d-none d-md-block">
                                <h2 className="text-warning bg-dark font-weight-bold ">Welcome to Saswat E-Commerce</h2>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
